import agentsChatHistoryReducer, { agentChatHistoryActions } from './agent-chat-history.slice';

export { agentChatHistoryActions };

export default agentsChatHistoryReducer;
